import axios, { AxiosResponse } from "axios";
import { keyList } from "../../modules/jwt";
import BaseInstance from "../BaseInstance";

export interface tokenResponse {
  id_token: string;
  access_token: string;
}

interface keyListResponse {
  keys: keyList;
}

export enum PermissionTypeAccess {
  GRANTED = "GRANTED",
  FORBIDDEN = "FORBIDDEN",
}

interface VerifyUserAccessResponse {
  type: string;
  entityIdentifier: string;
  access: PermissionTypeAccess;
  role: string;
}

const AuthGateway = {
  getUserToken: async (tokenUrl: string): Promise<AxiosResponse<tokenResponse>> => {
    return axios.post(tokenUrl);
  },

  getKeyList: async (keyListUrl: string): Promise<AxiosResponse<keyListResponse>> => {
    return axios.post(keyListUrl);
  },

  getUserData: async (dataUrl: string, token: string) => {
    return axios.get(dataUrl, { headers: { Authorization: `Bearer ${token}` } });
  },
  syncUser: async ({
    token,
  }: {
    token: string;
    user: any;
    id_token: string;
  }): Promise<AxiosResponse<number>> => {
    return axios.post(
      BaseInstance.defaults.baseURL + "users/sync",
      {},
      { headers: { Authorization: token } }
    );
  },
  verifyUserAccess: async (): Promise<VerifyUserAccessResponse> => {
    return BaseInstance.post("/users/application-access", {
      application: "web",
    });
  },
};

export default AuthGateway;
